export default "__VITE_ASSET__B1preov8__"